<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />

        <div class="row">
          <div class="col-xl-3 col-md-4">
            <settingsidebar />
          </div>

          <div class="col-xl-9 col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Preferences</h5>
              </div>
              <div class="card-body">
                <!-- Form -->
                <form @submit.prevent="updateSettings">
                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Currency</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.currency"
                        required
                      >
                        <option selected :value="null">Please select</option>
                        <option
                          v-for="(currency, index) in allCurrencyCodes"
                          :key="index"
                          :value="currency.code"
                        >
                          {{ `${currency.code} : ${currency.currency}` }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="timezoneLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Time Zone</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.timezone"
                        required
                      >
                        <option selected :value="null">Please select</option>
                        <option
                          v-for="(timezone, index) in Timezones"
                          :key="index"
                          :value="timezone"
                        >
                          {{ timezone }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="dateformat"
                      class="col-sm-3 col-form-label input-label"
                      >Date Format</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.date_format"
                        required
                      >
                        <option selected :value="null">Please select</option>
                        <option
                          v-for="(date, index) in dateformat"
                          :key="index"
                          :value="date"
                        >
                          {{ date }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      for="financialyear"
                      class="col-sm-3 col-form-label input-label"
                      >Financial Year</label
                    >
                    <div class="col-sm-9">
                      <select
                        class="form-select"
                        v-model="form.financial_year"
                        required
                      >
                        <option selected :value="null">Please select</option>
                        <option
                          v-for="(year, index) in year"
                          :key="index"
                          :value="year"
                        >
                          {{ year }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="text-end">
                    <button
                      :disabled="isLoading"
                      type="submit"
                      class="btn btn-primary add-tax-save-btn"
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Save Changes</span>
                      <span v-if="isLoading">Saving...</span>
                    </button>
                  </div>
                </form>
                <!-- /Form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
const currencyCodes = require("currency-codes");

// Get all currency codes
const allCurrencyCodes = computed(() => {
  return currencyCodes.data.map((currency) => currency);
});

const store = useStore();
const title = "Settings";
// const Timezones = ["Africa/Lagos"];
// const dateformat = ["Year - Month - Day"];
const isLoading = ref(false);
// const year = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
const date = new Date();

const form = ref({
  currency: "",
  timezone: "",
  date_format: "",
  financial_year: "",
});

const settings = computed(() => {
  return store.getters["settings/settings"];
});

const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    form.value = {
      currency: settings.value.currency,
      timezone: settings.value.timezone,
      date_format: settings.value.date_format,
      financial_year: settings.value.financial_year,
    };
    console.log(form.value)
  });


};

const updateSettings = () => {
  isLoading.value = true;
  store
    .dispatch("settings/updatePreferenceSettings", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  getSettings();
});
</script>
